import React, { Component } from 'react';
import propTypes from 'prop-types';
import { DropdownButton } from 'react-bootstrap';
import { ShortId } from 'client/components/Helpers/Strings';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import InstanceLogDescription from 'client/components/InstanceLog/components/InstanceLogDescription';
import { ModalButton, ModalFormattedObject } from 'client/components/Helpers/Modal';
import { TableThSort, TablePagination, TableShowCount } from 'client/components/Helpers/Table';
import Time from 'client/components/Helpers/Time';
import InstanceLogTableFilterForm from 'client/components/InstanceLog/components/InstanceLogTableFilterForm';
import LogLevelLabel from 'client/components/Helpers/LogLevelLabel';
import BeLoading from 'client/components/Be/BeLoading';

class InstanceLogTable extends Component {

  static defaultProps = {
    logs: [],
  };

  static propTypes = {
    logs: propTypes.array,
    filter: propTypes.object,
    orderBy: propTypes.string,
    orderDirection: propTypes.string,
    onOrderBy: propTypes.func,
    onSetPage: propTypes.func,
    onRefresh: propTypes.func,
    loading: propTypes.bool,
  };

  renderInstanceLogs () {
    const { logs } = this.props;
    if (!logs || !logs.length) return (
      <tr>
        <td className="empty" colSpan={6}>No logs to show</td>
      </tr>
    );
    return logs.map(log => {
      const { id, time, level, type, connectorInstanceId, Connector } = log;
      const { shortTitle } = Connector || {};
      return (
        <tr key={id}>
          <td><Time time={time} format="YYYY-MM-DD HH:mm:ss" /></td>
          <td><ShortId id={id} /></td>
          <td><LogLevelLabel level={level} /></td>
          <td>{type}</td>
          <td className="cell-detail">
            <span>{shortTitle || ''}</span>
            <span className="cell-detail-description">{connectorInstanceId}</span>
          </td>
          <td><InstanceLogDescription {...log} maxLineLength={100} /></td>
          <td className="text-right">
            <DropdownButton title={(<i className="icon mdi mdi-settings"></i>)} pullRight id={`table-row-actions-${log.id}`}>
              <li>
                <Link to={`/instance?id=${connectorInstanceId}`}>
                  <i className="icon mdi mdi-sign-in"></i>
                  Show parent instance
                </Link>
              </li>
              {level === 'job' && (
                <li>
                  <Link to={`/instance/log/fragment?connectorInstanceLogId=${log.id}`}>
                    <i className="icon mdi mdi-sign-in"></i>
                    Show fragments
                  </Link>
                </li>
              )}
              <li role="separator" className="divider" />
              <li>
                <ModalButton anchor className="btn-link" ModalComponent={ModalFormattedObject} modalProps={{object: log, title: type, inspector: 'object'}}>
                  <i className="icon mdi mdi-search"></i>
                  Inspect
                </ModalButton>
              </li>
            </DropdownButton>
          </td>
        </tr>
      );
    });
  }

  renderTable () {
    const { orderBy, orderDirection, onOrderBy, loading } = this.props;
    const sortProps = { orderBy, orderDirection, onClick: onOrderBy };
    return (
      <div className="be-datatable-body">
        <BeLoading loading={loading}>
          <table className="table table-striped table-hover dataTable">
            <thead>
              <tr>
                <TableThSort column="time" {...sortProps}>Time</TableThSort>
                <TableThSort column="id" {...sortProps}>ID</TableThSort>
                <TableThSort column="level" {...sortProps}>Level</TableThSort>
                <th>Type</th>
                <th>Connector/Instance</th>
                <th>Description</th>
                <th className="actions"></th>
              </tr>
            </thead>
            <tbody className="no-border-x">
              {this.renderInstanceLogs()}
            </tbody>
          </table>
        </BeLoading>
      </div>
    );
  }

  renderFooter () {
    const { limit, count, page, onSetPage, pages } = this.props;
    return (
      <div className="row be-datatable-footer">
        <div className="col-sm-5 sm-mb-0 xs-mb-15">
          <div className="dataTables_info">
            <TableShowCount limit={limit} count={count} pluralization={['log', 'logs']} />
          </div>
        </div>
        <div className="col-md-7">
          <div className="dataTables_paginate paging_simple_numbers">
            <TablePagination activePage={page} onSelect={onSetPage} items={pages} />
          </div>
        </div>
      </div>
    );
  }

  render () {
    const { filter, onFilter } = this.props;
    const classes = classNames('panel', 'panel-table', this.props.className);
    return (
      <div className={classes}>
        <div className="panel-heading">Table of Instance Logs</div>
        <div className="panel-body">
          <div className="dataTables_wrapper">
            <InstanceLogTableFilterForm
              onFilter={onFilter}
              filter={filter}
            />
            {this.renderTable()}
            {this.renderFooter()}
          </div>
        </div>
      </div>
    );
  }

}

export default InstanceLogTable;
